import Image from 'next/image'
import Trans from 'next-translate/Trans'
import useTranslation from 'next-translate/useTranslation'

import css from '@/views/well-being/scss/banner.module.scss'

function Banner() {
  const { t } = useTranslation('wellBeing')

  const handleScroll = (scrollTo: string): void => {
    const element = document.getElementById(scrollTo)
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' })
    }
  }

  return (
    <div className={css['banner']}>
      <div className="flex flex-col w-full h-full">
        <div className="flex flex-col md:p-8 lg:flex-row">
          <div className="flex flex-col items-center justify-center py-12 lg:w-1/2">
            <h1 className="text-5xl italic font-black text-center text-white 2xl:text-7xl">
              {t('banner_title')}
            </h1>
            <h1 className="text-5xl italic font-black text-center text-white 2xl:text-7xl">
              {t('banner_title_0')}
            </h1>
          </div>
          <div className="flex flex-col items-center justify-center p-6 md:p-8 text-center lg:w-1/2 text-[#545584]">
            <Trans
              i18nKey="wellBeing:banner_title_1"
              components={[
                <p
                  className="flex text-2xl font-extrabold uppercase 2xl:text-3xl"
                  key={0}
                />,
                <p key={1} className="mb-6 ml-1 font-normal" />,
              ]}
            />
            <p className="mb-12 text-sm lg:text-base 2xl:text-lg">
              {t('banner_copy_1')}
            </p>
            <Trans
              i18nKey="wellBeing:banner_copy_2"
              components={[
                <p className="text-sm lg:text-base 2xl:text-lg" key={0} />,
                <p
                  key={1}
                  className="mb-16 text-sm font-bold lg:text-base 2xl:text-lg"
                />,
              ]}
            />
            <button
              onClick={() => handleScroll('contact')}
              className="px-4 py-2 font-bold text-white uppercase md:px-6 md:py-3 md:text-lg bg-green-60"
            >
              {t('button_banner')}
            </button>
          </div>
        </div>
        <div className="flex flex-col items-center justify-center px-6 mt-32 lg:mt-4 lg:flex-row">
          <div className="flex flex-col items-center justify-center md:px-8 lg:w-1/2">
            <p className="text-center uppercase italic font-bold text-5xl 2xl:text-7xl text-[#545584] lg:w-1/2">
              {t('banner_about_us')}
            </p>
            <Trans
              i18nKey="wellBeing:banner_copy_3"
              components={[
                <p
                  className="text-center text-sm xl:text-base 2xl:text-lg font-semibold my-8 text-[#545584] lg:w-3/4"
                  key={0}
                />,
                <a
                  href={'/'}
                  key={1}
                  className="underline hover:text-violet-100"
                />,
              ]}
            />
            <p className="text-center text-sm xl:text-base 2xl:text-lg text-[#545584] lg:w-3/4">
              {t('banner_copy_4')}
            </p>
          </div>
          <div className="flex items-end justify-center -mt-4 md:ml-2 lg:mt-0 lg:px-0 lg:w-1/2">
            <div className="h-max w-72 xs:w-96 lg:w-full ">
              <Image
                alt={t('results.none')}
                src={`/images/well-being/banner-element.png`}
                height="75%"
                width="105%"
                layout="responsive"
                quality={75}
                loading="eager"
              />
            </div>
          </div>
        </div>
        <div className="bg-violet-60">
          <div className="relative flex flex-col items-center justify-center py-12 bg-white md:py-24 rounded-bl-4xl rounded-br-4xl">
            <p className="text-center text-sm text-[#837DDD] px-6 md:w-4/5 xl:text-base 2xl:text-lg">
              {t('banner_copy_5')}
            </p>
            <div className="absolute bottom-0 w-16 h-8 rounded-tl-full rounded-tr-full bg-violet-60"></div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Banner
